import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=5f5ac2af&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f5ac2af')) {
      api.createRecord('5f5ac2af', component.options)
    } else {
      api.reload('5f5ac2af', component.options)
    }
    module.hot.accept("./ProductCategory.vue?vue&type=template&id=5f5ac2af&", function () {
      api.rerender('5f5ac2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/products/ProductCategory.vue"
export default component.exports